import React, { useEffect, useContext, useState } from 'react';
import { GoogleMap, useJsApiLoader,InfoWindow } from '@react-google-maps/api';
import { LoadScript, Marker } from "@react-google-maps/api";
import { Link } from 'react-router-dom';
import { AppSettings } from './../../config/app-settings.js';
import blangoua from "../../assets/img/maps/blangoua.jpg";
import darak from "../../assets/img/maps/darak.jpg";
import fotokol from "../../assets/img/maps/fotokol.jpg";
import goulfey from "../../assets/img/maps/goulfey.jpg";
import hile_alifa from "../../assets/img/maps/hile_alifa.jpg";
import kousseri from "../../assets/img/maps/kousseri.jpg";
import longoni_birni from "../../assets/img/maps/longoni_birni.jpg";
import makary from "../../assets/img/maps/makary.jpg";
import waza from "../../assets/img/maps/waza.jpg";
import zina from "../../assets/img/maps/zina.jpg";




function MapGoogle() {
  const context = useContext(AppSettings);
  const [map, setMap] = useState(null); // eslint-disable-line no-unused-vars
  const [selectedMarker, setSelectedMarker] = useState(null);
  /*var center = {
		lat: 7.365302,
		lng: 12.343439499999988
  }; */


  const center = {
     lat: 12.0700,
		lng: 14.4200
  };
  
	var containerStyle = {
		width: '100%',
		height: '100%'
	};
	
  const markers = [
    { lat: 12.7675, lng: 14.5758, name: "BLANGOUA" , img : blangoua }, 
    { lat: 12.8833, lng: 14.3000, name: "DARAK" , img : darak },
    { lat: 12.3667, lng: 14.2333, name: "FOTOKOL" , img : fotokol },
    { lat: 12.3833, lng: 14.9333, name: "GOULFEY" , img : goulfey },
    { lat: 12.5742, lng: 14.4539, name: "MAKARY" , img : makary },
    { lat: 11.7833, lng: 15.1000, name: "LOGONE BIRNI" , img : longoni_birni }, 
    { lat: 12.0767, lng: 15.0306, name: "KOUSSERI" , img : kousseri },
    { lat: 12.7000, lng: 14.3167, name: "HILE-ALIFA" , img : hile_alifa },
    { lat: 11.3989, lng: 14.5708, name: "WAZA" , img : waza },
    { lat: 11.2625, lng: 14.9653, name: "ZINA" , img : zina }
  ];

 
	var { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    //googleMapsApiKey: "AIzaSyBxkehr0NrofIT0wlJ4d6QFZc4o8ro1Yoc"
    googleMapsApiKey: ""
  })
  
  const onLoad = React.useCallback(function callback(map) {
    const bounds = new window.google.maps.LatLngBounds(this.center);
    map.fitBounds(bounds);

    setMap(map)
  }, [])

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null)
  }, [])

  useEffect(() => {
    context.handleSetAppContentFullHeight(true);
    context.handleSetAppContentClass('p-0 position-relative');

    return () => {
      context.handleSetAppContentFullHeight(false);
      context.handleSetAppContentClass('');
    };
    
		// eslint-disable-next-line
  }, []);

  return (
    <div>
      <div className="position-absolute w-100 h-100 top-0 start-0 bottom-0 end-0">
        { isLoaded ? (
            <GoogleMap mapContainerStyle={containerStyle} 
            zoom ={2}
						onLoad={onLoad}
						onUnmount={onUnmount}>            
            {markers.map((marker, index) => (
              <Marker 
                key={index} 
                position={marker} 
                onClick={() => setSelectedMarker(marker)}
              />
            ))}
      
       {selectedMarker && (
        <InfoWindow
          position={selectedMarker}
          onCloseClick={() => setSelectedMarker(null)}>
              <div style={{ color: "red",fontSize:"20px", fontWeight: "bold",textAlign : "center"}}> 
              <b>{selectedMarker.name ? selectedMarker.name : "Unnamed Location"} </b> 
              <hr/>         
              {selectedMarker.img && (
                <img
                  src={selectedMarker.img}
                  alt={selectedMarker.name || "Location Image"}
                  style={{marginBottom: "8px" ,width:"600px" }}
                />
              )}
             
          </div>
        </InfoWindow>
       )}      
          </GoogleMap>
				) : <></>
				}
      </div>

      <div className="app-content-padding position-relative">
        <ol className="breadcrumb float-xl-end">
          <li className="breadcrumb-item"><Link to="/map" className="text-white">Home</Link></li>
          <li className="breadcrumb-item active text-white">Map</li>
        </ol>
        <h1 className="page-header text-white">Google Map </h1>
      </div>
    </div>
  );
}

export default MapGoogle;